import {AbstractCommandToDtoTransformer} from "./abstract-command-to-dto.transformer";
import {Project} from "../domain/entities/project.entity";
import {transformer} from "../decorators/transformer.decorator";
import {TransformerHelper} from "../helpers/transformer.helper";
import {DataTransferObject} from "../domain/dtos/data-transfer-object.interface";
import {injectable} from "tsyringe";
import {UpdateProjectCommand} from "../commands/update-project.command";

@injectable()
@transformer({
    source: UpdateProjectCommand,
    target: `dto`
})
export class UpdateProjectCommandToDtoTransformer extends AbstractCommandToDtoTransformer<Project> {

    protected async toDTO(project: Project): Promise<DataTransferObject> {
        return TransformerHelper.toDTO(project);
    }
}